import { render, staticRenderFns } from "./image-element.vue?vue&type=template&id=5c3ee3a8&scoped=true"
import script from "./image-element.vue?vue&type=script&lang=js"
export * from "./image-element.vue?vue&type=script&lang=js"
import style0 from "./image-element.vue?vue&type=style&index=0&id=5c3ee3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3ee3a8",
  null
  
)

export default component.exports